import { render, staticRenderFns } from "./AppReportHeader.vue?vue&type=template&id=50cd8b72&"
import script from "./AppReportHeader.vue?vue&type=script&lang=js&"
export * from "./AppReportHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports